import ReadMoreEditing from './readmoreediting';
import ReadMoreUI from './readmoreui';
import { Plugin } from 'ckeditor5';

export default class ReadMore extends Plugin {
    static get requires() {
        return [ ReadMoreEditing, ReadMoreUI ];
    }
}
